export default __webpack_public_path__ + "static/media/our-service-commercial-background.57432d5b.jpg";